'use client';

import { useMemo } from 'react';

import { useDateTimes } from '@personly/libs-providers';

interface Props {
  days: number;
  interval: number;
  placeholder: string;
}

const CookieExpires = ({ days, interval, placeholder }: Props) => {
  const dateTimes = useDateTimes();

  const toExpires = useMemo(
    () => (days === 0 ? placeholder : dateTimes.timeSince(interval)),
    [placeholder, dateTimes, days, interval]
  );

  return toExpires;
};

export default CookieExpires;
